import {
  SAVE_APPLICATION_SUCCESS,
  SAVE_APPLICATION_FAIL,
  UPDATE_APPLICATION_DATA,
  RESUME_APPLICATION_SUCCESS,
  PROCESS_APPLICATION_FAIL,
  PROCESS_APPLICATION_SUCCESS,
  PROCESS_APPLICATION_START,
  PARTNER_INSURANCE_SUCCESS,
  PARTNER_INSURANCE_FAIL,
  INVALIDATE_APPLICATION,
  RESUME_APPLICATION_START,
  SAVE_APPLICATION_START,
  RESUME_APPLICATION_FAIL,
  CLIENT_SIGNUP_SAVE_SUCCESS,
  CLIENT_SIGNUP_RESUME_SUCCESS,
  CLIENT_UPDATE_APPLICATION_INPUT,
  CLIENT_UPDATE_APPLICATION,

  SIGNUP_APPLICATION_STRIPE_LOADING,
  SIGNUP_APPLICATION_STRIPE_FAILED,
} from '../actions/types';

export const INITIAL_STATE = {
  
  currentSignupStep: 0,
  applicationVersion: '1.0',
  applicationID: '',
  applicationData: {
    firstname:'',
    lastname:'',
    email:'',
    birthdate: new Date().setFullYear(new Date().getFullYear() - 18),
    planCategory:'',
    planCode:'',
    planConfirm:'',
    company: {
      name: '',
      type:'',
      postal: '',
      existingCustomer: false,
    },
    employCompany:{
      fiscalDate: new Date(),
      planYearType: '',
      onlineAgreement: '',
      acknowledgePAC: false
    },
    incorpCompany:{
      adminAgreement: '',
      employeeConfirmation: '',
    },
    hasSecondEmployee: false,
    secondEmployee: {
      firstname:'',
      lastname:'',
      email:'',
      birthdate: new Date(),
    },
    errors:{

    },
    openModal: '',
    signupStep: 1,
  },
  applicationValidation:{
    firstname:{
      required: true,
      isName: true,
    },
    lastname:{
      required: true,
      isName: true,
    },
    email:{
      required: true,
      isEmail: true,
    },
    birthdate: {
      required: true,
      isOver18: true,
    },
    planCategory: {
      isProduct: true,
    },
    planCode:{
      isPlan: true,
    },
    planConfirm:{
      required: true,
      isChecked: true,
    },
    company: {
      name:{
        required: true,
        isCompanyName: true,
      },
      type:{
        required: true,
        isNumeric: true,
      },
      postal:{
        required: true,
        isPostal: true,
        isServiced: true
      },
      existingCustomer: {

      },
    },
    employCompany: {
      fiscalDate: {
        required: true,
        isDate: true,
      },
      planYearType: {
        required: true,
        isDate: true,
      },
      onlineAgreement: {
        required: true,
        isChecked: true,
      },
      acknowledgePAC: {
        required: true,
        isChecked: true,
      }
    },
    incorpCompany: {
      adminAgreement: {
        required: true,
        isChecked: true,
      },
      employeeConfirmation: {
        required: true,
        isChecked: true,
      },
    },
    secondEmployee: {
      firstname:{
        required: true,
        isName: true,
      },
      lastname:{
        required: true,
        isName: true,
      },
      email:{
        required: true,
        isEmail: true,
      },
      birthdate: {
        required: true,
        isOver18: true,
      },
    }
  },
  partnerID: '1',
  partnerNotInsured: 'N',
  partnerInsuredProvinces: [],
  allowPartnerRemove: false,
  processSuccess: false,
  addSecondEmployee: false,
  openModal: '',
  hubspotID: '',
  loading: false,
  error: '',
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case INVALIDATE_APPLICATION:
        return {...INITIAL_STATE, processSuccess: true}
      case CLIENT_UPDATE_APPLICATION_INPUT:
        return (action.fieldGroup !== '')?
        { ...state, applicationData: {...state.applicationData, [action.fieldGroup]: {...state[action.fieldGroup], [action.fieldName]: action.fieldValue } }, error: false, errors: {}, loading: false }
        :
        { ...state, applicationDate: {...state.applicationData, [action.fieldName]: action.fieldValue }, error: false, loading: false };
      case CLIENT_UPDATE_APPLICATION:
        return {...state, applicationData: {...state.applicationData, ...action.fieldData } }
      case RESUME_APPLICATION_START:
        return { ...state,
                loading: true,
        };
      case RESUME_APPLICATION_FAIL:
        return { ...state,
                loading: false,
        };
      case RESUME_APPLICATION_SUCCESS:
        return { ...state,
                 ...action.applicationData,
                 loading: false,
                 currentSignupStep: 0,
                 error: '',
        };
      case UPDATE_APPLICATION_DATA:
        return { ...state,
          [action.fieldName]: action.fieldValue
        };
      case SAVE_APPLICATION_START:
        return { ...state,
                loading: true,
        };
      case SAVE_APPLICATION_SUCCESS:
        return { ...state,
                ...action.applicationData,
                applicationID: action.applicationID,
                currentSignupStep: state.currentSignupStep + 1,
                processSuccess: false,
                loading: false,
                error: '',
        };
      case SAVE_APPLICATION_FAIL:
        return { ...state,
                ...action.applicationData,
                applicationID: action.applicationID,
                loading: false,
        };
      case SIGNUP_APPLICATION_STRIPE_LOADING:
        return {
          ...state,
          loading: true,
        };
      case SIGNUP_APPLICATION_STRIPE_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error
        };
      case PROCESS_APPLICATION_START:
        return { ...state,
                    error: '',
                    loading: true,
                    processSuccess: false,
        };
      case PROCESS_APPLICATION_SUCCESS:
        return { ...state,
                    error: '',
                    loading: false,
                    processSuccess: true,
                    currentSignupStep: 3,
        };
      case PROCESS_APPLICATION_FAIL:
        return { ...state,
                    loading: false,
                    error: action.error,
                    processSuccess: false,
                    currentSignupStep: 2,
        };
      case PARTNER_INSURANCE_SUCCESS:
        return { ...state,
          loading: false,
                    errors: true,
                    error: action.error,
                    partnerID: action.data.partnerID,
                    partnerInsuredProvinces: action.data.partnerInsuredProvinces,
                    partnerNotInsured: action.data.partnerNotInsured,
                    partnerName: action.data.partnerName,
                    
        };
      case PARTNER_INSURANCE_FAIL:
        return { ...state,
                    loading: false,
                    errors: true,
                    error: action.error,
                    partnerID: 1,
                    partnerInsuredProvinces: [],
                    partnerName: '',
                    partnerNotInsured: 'N',
                    applicationData: { ...state.applicationData,
                      planCode: ''
                    }
        };
        
      case CLIENT_SIGNUP_SAVE_SUCCESS:
        return { ...state,
                    applicationID: action.data.appid
                };

      case CLIENT_SIGNUP_RESUME_SUCCESS:
        return { ...state,
                  applicationID: action.data.appid,
                  applicationData: action.data.appdata
                };
      default:
        return state;
    }
};

export default reducer;